import { IRowProps, rowStyles } from 'components/general/RowedExplorer/Row/styles';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles<IRowProps>()((theme, props) => rowStyles(props));

export default useStyles;
